import {Alert, AlertTitle, Button, Slide, Snackbar, SxProps} from '@mui/material';
import {
  CancelOutlined,
  CheckCircleOutlineOutlined,
  InfoOutlined,
  WarningAmberOutlined,
} from '@mui/icons-material';
import {useSnackBar} from '../../../contexts/snack-bar/context';
import {appSizes} from '../../../utils/constants';

const snackBarSx: SxProps = {
  zIndex: 9999,
  display: 'flex',
  alignItems: 'flex-end',
  left: '10px!important',
  right: '10px!important',
  width: 'calc(100% - (10px * 2px))',
  top: `${appSizes.dailyCareLog.headerHeight + 10}px !important`,
  alignContent: 'flex-end',
};

const alertSx: SxProps = {
  padding: '25px 10px',
  gap: '18px',
  minHeight: '120px',
  '.MuiAlert-message': {
    fontSize: '20px',
    fontWeight: 500,
    color: 'var(--dcm-gray)',
    lineHeight: 'normal',
  },
  '.MuiAlert-icon': {
    width: '20px',
    height: '20px',
    fontSize: '20px',
    padding: 0,
  },
};

export const AlertSnackbar = () => {
  const snackBarContext = useSnackBar();

  return (
    <Snackbar
      key={`${snackBarContext.state.dailyCareLogToastNotification.message}_${snackBarContext.state.dailyCareLogToastNotification.severity}`}
      TransitionComponent={Slide}
      anchorOrigin={{vertical: 'top', horizontal: 'left'}}
      open={snackBarContext.state.dailyCareLogToastNotification.open}
      autoHideDuration={snackBarContext.state.dailyCareLogToastNotification.autoHideDuration}
      onClose={snackBarContext.resetDailyCareLogToastNotification}
      sx={snackBarSx}
    >
      <Alert
        variant="outlined"
        onClose={snackBarContext.resetDailyCareLogToastNotification}
        severity={snackBarContext.state.dailyCareLogToastNotification.severity}
        action={
          snackBarContext.state.dailyCareLogToastNotification.buttonLabel && (
            <Button color="inherit" size="small">
              {snackBarContext.state.dailyCareLogToastNotification.buttonLabel}
            </Button>
          )
        }
        iconMapping={{
          info: <InfoOutlined />,
          success: <CheckCircleOutlineOutlined />,
          error: <CancelOutlined />,
          warning: <WarningAmberOutlined />,
        }}
        sx={alertSx}
      >
        {snackBarContext.state.dailyCareLogToastNotification.title && (
          <AlertTitle>{snackBarContext.state.dailyCareLogToastNotification.title}</AlertTitle>
        )}
        {snackBarContext.state.dailyCareLogToastNotification.message}
      </Alert>
    </Snackbar>
  );
};
